<template>
  <section class="settings-system-alerts-form">
    <embed-frame
      class="settings-system-alerts-form-frame"
      endpoint="system_alerts/form"
      placeholder="Carregando..."
      :settings="embedSettings"
      :callbacks="embedCallbacks"
    />
  </section>
</template>

<script>
  import EmbedFrame from '@sdk/views/Embed/Frame.vue';

  export default {
    name: 'SystemAlertsForm',
    components: {
      EmbedFrame,
    },
    computed: {
      embedSettings() {
        return {
          system_alerts: {
            form: {
              id: this.$route.params.id,
            },
          },
        };
      },
      embedCallbacks() {
        return {
          'system_alert:create': this.callback,
          'system_alert:update': this.callback,
        };
      },
    },
    methods: {
      callback() {
        this.$router.push({
          name: 'settings-system-alerts',
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .settings-system-alerts-form {
    padding: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      padding: 0 var(--product--pwa--horizontal);
    }
  }
</style>
